var _style, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:#E6E6E6;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st2{fill:#00314D;stroke:#000000;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.0934,
    y1: 137.5419,
    x2: 285.9066,
    y2: 879.1833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#2ACCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    style: {
      stopColor: "#78878C"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 508.36,
    r: 428.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 500,
    cy: 508.36,
    r: 328.53
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 500,
    cy: 508.36,
    r: 309.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlat);
export default __webpack_public_path__ + "static/media/Plat.80595b5fd051b948b77fc21d8ca9b168.svg";
export { ForwardRef as ReactComponent };